export default "__VITE_ASSET__CgqNYdYd__"